import React, { useState } from 'react'
import { Form, Button, Modal, Col, Row } from 'antd'
import { observer } from 'mobx-react'
import useStore from "../../../../store";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import debounce from "lodash/debounce";
import InputComponent from '../../../../component/InputComponent';
import { vsmNotify, vsmInsurancePayoutMarkAsApproved } from '../../../../config/messages';

const MarkAsApprovedComponent = observer((props) => {
	const [form] = Form.useForm()
	const { InsurancePayoutsAllStore: { MarkAsApprovedData, payout_detail } } = useStore()
	const [saving, setSaving] = useState()
	const [disabled, setDisabled] = useState(true);

	// Handle submit and call function to save new record
	const handleSubmit = (data) => {
		if (validate()) {

			MarkAsApprovedData(payout_detail.ins_payout?.id, data).then((res) => {
				vsmNotify.success({
					message: res.STATUS.NOTIFICATION[0],
				});
				close();
			})
				.catch((e) => {
					// console.log("error......", e);
					if (e.errors) {
						form.setFields(e.errors);
					}
				})
				.finally(() => setSaving(false));
		}
		else {
			vsmNotify.error({
				message: "It cannot be greater than expected amount",
			});
		}
	};

	const validate = () => {
		let isValid = true;
		if (form.getFieldValue("approved_amount") > payout_detail.ins_payout?.expected) {
			isValid = false;
		}
		return isValid;
	}


	// check for valid form values then accordingly make save button disable/enable
	const handleChange = debounce(() => {
		form
			.validateFields()
			.then((d) => {
				setDisabled(false);
			})
			.catch((d) => {
				setDisabled(true);
			});
	}, 500);

	// reset form and close add form
	const close = () => {
		props.close();
		form.resetFields();
		setDisabled(true);
	};

	return (
		<Modal
			centered
			title={`Mark as Approved`}
			visible={props.visible}
			onCancel={close}
			closeIcon={<FontAwesomeIcon icon={faTimes} />}
			cancelButtonProps={{ style: { display: 'none' } }}
			okButtonProps={{ style: { display: 'none' } }}
			footer={[
				<Button
					key="1"
					className="mr-35"
					form="markAsApprovedInsurancePayoutForm"
					loading={saving}
					disabled={disabled}
					htmlType="submit"
					type="primary"
				>
					Save
				</Button>,
				<Button
					key="2"
					htmlType="button"
					className="cancelBtn"
					onClick={close}
				>
					Cancel
				</Button>,
			]}
		>
			<Form form={form} layout="vertical" id="markAsApprovedInsurancePayoutForm" onFinish={handleSubmit} onChange={handleChange}>
				<Row align="middle">
					<Col span={24}>
						{`Assuming that the finance claim request is approved. Would you like to mark as approved?`}
					</Col>

					<Col span={24} className="mt-20">
						<InputComponent
							type="text"
							label="Approved Amount"
							placeholder="Approved Amount"
							name="approved_amount"
							required
							onChange={handleChange}
							rules={vsmInsurancePayoutMarkAsApproved.validation.approved_amount}
						/>
					</Col>

					<Col span={24} className="mt-20">
						<InputComponent
							type="textarea"
							label="Notes"
							placeholder="Notes"
							name="notes"
							required
							onChange={handleChange}
							rules={vsmInsurancePayoutMarkAsApproved.validation.remark}
						/>
					</Col>
				</Row>
			</Form>
		</Modal >
	)
})

export default MarkAsApprovedComponent
